// src/store/slices/dashboardSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subcategoryRedux: null,
  materialRedux: null,
  hsnCodeRedux: null,
  originCountryRedux: [],
  destinationCountryRedux: [],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSubcategoryRedux: (state, action) => {
      state.subcategoryRedux = action.payload;
    },
    setMaterialRedux: (state, action) => {
      state.materialRedux = action.payload;
    },
    setHsnCodeRedux: (state, action) => {
      state.hsnCodeRedux = action.payload;
    },
    setOriginCountryRedux: (state, action) => {
      state.originCountryRedux = action.payload;
    },
    setDestinationCountryRedux: (state, action) => {
      state.destinationCountryRedux = action.payload;
    },
    resetDashboardRedux: (state) => {
      state.subcategoryRedux = null;
      state.materialRedux = null;
      state.hsnCodeRedux = null;
      state.originCountryRedux = [];
      state.destinationCountryRedux = [];
    },
  },
});

export const {
  setSubcategoryRedux,
  setMaterialRedux,
  setHsnCodeRedux,
  setOriginCountryRedux,
  setDestinationCountryRedux,
  resetDashboardRedux,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
